import React, { FunctionComponent, useContext } from 'react';
import styled from 'styled-components';
import { BrandStore } from '../../context';
import { Button, ButtonProps, Group } from '../index';

const StyledButton = styled(Button)`
  border-radius: 0;
  padding: 2rem 1rem;
  bottom: 0%;
  position: absolute;
  display: flex;
  flex-direction: column;

  > span {
    text-align: right;
    font-family: 'AvenirNextUltraLight', sans-serif;

    &:first-child {
      font-size: 14px;
      color: ${(props: ButtonProps) => props.theme!.colors.accentText};
    }

    &:last-child {
      font-size: 18px;
      color: ${(props: ButtonProps) => props.theme!.colors.hyperlink};
    }
  }
`;

export const ContactButton: FunctionComponent = props => {
  const {
    state: { brand },
  } = useContext(BrandStore);
  return (
    <Group justify="end">
      <StyledButton
        motif="primary"
        id="contact-us-button"
        data-testid="contact-us-button"
        onClick={() =>
          (window.location.href = `mailto:${
            brand?.supportEmail || 'support@fattmerchant.com'
          }`)
        }
      >
        <span>Questions?</span>
        <span>Contact Us</span>
      </StyledButton>
    </Group>
  );
};
